import {
  Box,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material';
import { useRef, useState } from 'react';
import { Button, TrashIcon } from '@/shared/ui';
import { CWEventSelect, CWEvent } from '../CWEventSelect/CWEventSelect';
import {
  IncludingParam,
  IncludingParamSelect,
} from '../IncludingParamSelect/IncludingParamSelect';
import {
  PartnerEvent,
  PartnerEventSelect,
} from '../PartnerEventSelect/PartnerEventSelect';

interface EventPostback {
  cwEvent: CWEvent;
  partnerEvent: PartnerEvent;
  includingParam: IncludingParam;
}

export function EventPostbacksTable() {
  const tableRef = useRef<HTMLTableElement>(null);
  const [eventPostbacks, setEventPostbacks] = useState<EventPostback[]>([]);

  const addEventPostback = () => {
    setEventPostbacks([
      {
        cwEvent: CWEvent.cw_subscribe,
        partnerEvent: PartnerEvent.subscribe,
        includingParam: IncludingParam.none,
      },
      ...eventPostbacks,
    ]);
    tableRef.current?.scrollTo(0, 0);
  };
  const removeEventPostback = (index: number) => {
    setEventPostbacks(eventPostbacks.filter((_, i) => i !== index));
  };
  const updateEventPostback = (index: number, eventPostback: EventPostback) => {
    setEventPostbacks(
      eventPostbacks.map((e, i) => (i === index ? eventPostback : e)),
    );
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: 2,
      }}
    >
      <Button
        sx={{ lineHeight: '1.125rem', borderRadius: 2 }}
        onClick={addEventPostback}
      >
        Add event
      </Button>
      <Table
        sx={{
          width: 'inherit',
          display: 'block',
          maxHeight: 300,
          overflow: 'auto',
        }}
        ref={tableRef}
        size="small"
        stickyHeader
      >
        <TableHead>
          <TableRow>
            <TableCell sx={{ pl: 0 }}>Campaignwell event</TableCell>
            <TableCell>Partner event</TableCell>
            <TableCell>Including</TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {eventPostbacks.length === 0 && (
            <TableRow>
              <TableCell colSpan={4} align="center">
                No event postbacks added
              </TableCell>
            </TableRow>
          )}
          {eventPostbacks.map((eventPostback, index) => {
            const { cwEvent, partnerEvent, includingParam } = eventPostback;

            return (
              <TableRow key={index} sx={{ position: 'relative' }}>
                <TableCell sx={{ pl: 0 }}>
                  <CWEventSelect
                    value={cwEvent}
                    onChange={(v) =>
                      updateEventPostback(index, {
                        ...eventPostback,
                        cwEvent: v,
                      })
                    }
                  />
                </TableCell>
                <TableCell>
                  <PartnerEventSelect
                    value={partnerEvent}
                    onChange={(v) =>
                      updateEventPostback(index, {
                        ...eventPostback,
                        partnerEvent: v,
                      })
                    }
                  />
                </TableCell>
                <TableCell>
                  <IncludingParamSelect
                    value={includingParam}
                    onChange={(v) =>
                      updateEventPostback(index, {
                        ...eventPostback,
                        includingParam: v,
                      })
                    }
                  />
                </TableCell>
                <TableCell>
                  <IconButton onClick={() => removeEventPostback(index)}>
                    <TrashIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
      <Box sx={{ display: 'flex', gap: 2 }}>
        <Button sx={{ lineHeight: '1.125rem', borderRadius: 2 }}>Save</Button>
        <Button
          variant="outlined"
          color="secondary"
          sx={{ lineHeight: '1.125rem', borderRadius: 2 }}
        >
          Cancel
        </Button>
      </Box>
    </Box>
  );
}
